import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=a5098f28&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"
import style1 from "./Modal.vue?vue&type=style&index=1&id=a5098f28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5098f28",
  null
  
)

export default component.exports